import { render, staticRenderFns } from "./ClientsStatistics.vue?vue&type=template&id=3faa3ca5&"
import script from "./ClientsStatistics.vue?vue&type=script&lang=js&"
export * from "./ClientsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports